import { TOption } from '@src/types';
import {
  AccountActivityActiveStatus,
  AccountActivityDisplay,
  FindDuplicatesByType,
  Notes,
  TAccountActivity,
  TNotesTable,
  TUserTable,
  UserType,
} from '@src/types/users.ts';

export const accountActivityCheckbox: TOption[] = [
  { label: 'Show Evals', value: AccountActivityDisplay.ShowEvals },
  { label: 'Show PAs', value: AccountActivityDisplay.ShowPas },
  { label: 'Show Addons', value: AccountActivityDisplay.ShowAddons },
];

export const accountActivityRadio: TOption[] = [
  { label: 'Live Only', value: AccountActivityActiveStatus.LiveOnly },
  { label: 'All Accounts', value: AccountActivityActiveStatus.AllAccounts },
];
export const notesRadio: TOption[] = [
  { label: 'All', value: Notes.ALl },
  { label: 'Flag', value: Notes.Flag },
  { label: 'Payouts', value: Notes.Payouts },
];

export const extraTradingDays: TOption[] = [
  { label: '1 Day', value: '1' },
  { label: '2 Days', value: '2' },
  { label: '3 Days', value: '3' },
  { label: '4 Days', value: '4' },
  { label: '5 Days', value: '5' },
  { label: '6 Days', value: '6' },
  { label: '7 Days', value: '7' },
  { label: '8 Days', value: '8' },
  { label: '9 Days', value: '9' },
  { label: '10 Days', value: '10' },
];

export const userTypeData: TOption[] = [
  {
    label: 'Users',
    value: UserType.Users,
  },
  {
    label: 'Duplicate Users',
    value: UserType.DuplicateUsers,
  },
];

export const findDuplicatesBy: TOption[] = [
  {
    label: 'Phone Numbers',
    value: FindDuplicatesByType.PhoneNumber,
  },
  {
    label: 'Street & ZIP',
    value: FindDuplicatesByType.Address,
  },
];

export const accountActivityTable: TAccountActivity[] = [
  {
    userId: 'LL783278632',
    userName: 'John Doe',
    accountId: 'LE-LL0087623123-144',
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    trading: 10,
    balance: 159056,
    balancedAt: new Date().toISOString(),
    status: `Awaiting Staff Approval Account (with addon) reached qualifying balance on 05 mae 2025`,
  },
  {
    userId: 'LL783278632',
    userName: 'John Doe',
    accountId: 'LE-LL0087623123-144',
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    trading: 10,
    balance: 159056,
    balancedAt: new Date().toISOString(),
    status: `Awaiting Staff Approval Account (with addon) reached qualifying balance on 05 mae 2025`,
  },
  {
    userId: 'LL783278632',
    userName: 'John Doe',
    accountId: 'LE-LL0087623123-144',
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    trading: 10,
    balance: 159056,
    balancedAt: new Date().toISOString(),
    status: `Awaiting Staff Approval Account (with addon) reached qualifying balance on 05 mae 2025`,
  },
];

export const notesTable: TNotesTable[] = [
  {
    userId: '1',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '2',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '3',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '4',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '5',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '6',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '7',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '8',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
  {
    userId: '9',
    date: new Date().toISOString(),
    userName: 'John Doe',
    note: 'Manual Closure of Rithmic Account LB-LL008282-008-WGSUJH',
  },
];

export const users: TUserTable[] = [
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
  {
    userId: 'LL000878',
    userName: 'Wilson Moreno',
    phoneNumber: '328087465',
    isActive: true,
    accountNo: `PA-WilsonMoreno-223`,
    accountDes: '3 Contract | $25,000 Aspire | Investor',
    package: '3 Contract | $25,000 Aspire | Investor',
    totalProfit: 617,
    maxAllowedDailyProfit: 185,
    highestDailyProfit: 197,
    highestDailyProfitPercent: 31,
    tradingDays: 12,
    customerPayouts: 3000,
    totalCustomerPayouts: 3,
  },
];
